import React, { Fragment } from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    withStyles,
} from "@material-ui/core";
import { Close } from '@material-ui/icons';
import { receive_appointmentsList } from "../../../apis/redux/fetchActions";
import APIService from "../../../apis/amplify/APIService";
import { getStatusText } from "../../../apis/cell_phone_solutions/appointmentsStatus";
import { formatCurrency, formatDate } from '../../../util/formatters';
import SectionTitleContainer, { SectionTitle } from "../../../components/SectionTitleContainer";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import Loading, { LoadingText, Progress } from '../../../components/Loading';
import If from "../../../components/If";
import { styles } from './styles'
import Notification, { NActionButton, SUCCESS_TYPE, ERROR_TYPE } from "../../../components/Notification";

const LOADING_MSG = 'Loading pending appointments...';
const CANCELING_MSG = 'Cancelling appointment...';

class PendingAppointmentContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingText: LOADING_MSG,
            cancelAppointmentConfirmationDialogOpen: false,
            pendingCancellingAppointmentId: null,
            snackBarOpen: false,
            notifySuccess: true,
            snackBarText: '',
        }
    }

    componentDidMount() {
        this.loadAppointments();
    }

    componentWillUnmount() {
        this.props.actions.receiveAppointmentsList([]);
    }

    loadAppointments() {
        this.setState({ loadingText: LOADING_MSG });
        APIService.getAppointmentList()
            .then((response) => {
                response.sort((a, b) => {
                    return parseInt(a.title.split(" ")[2], 10) > parseInt(b.title.split(" ")[2], 10);
                });
                this.props.actions.receiveAppointmentsList(response);
            })
            .finally(() => {
                this.setState({ loading: false });
            })
    }

    cancelAppointment(id) {
        this.setState({ cancelAppointmentConfirmationDialogOpen: true, pendingCancellingAppointmentId: id });
    }

    async processDelete() {
        this.setState({
            loading: true,
            loadingText: CANCELING_MSG,
            cancelAppointmentConfirmationDialogOpen: false
        });
        const { pendingCancellingAppointmentId } = this.state;
        const { ok } = await APIService.cancelAppointmentByCustomer(pendingCancellingAppointmentId);
        let stateUpdate = {
            loading: false,
            snackBarOpen: true,
            pendingCancellingAppointmentId: null
        };
        if (ok) {
            stateUpdate = {
                ...stateUpdate,
                notifySuccess: true,
                snackBarText: 'Appointment cancelled successfully.',
            };
            this.loadAppointments();
        } else {
            stateUpdate = {
                ...stateUpdate,
                notifySuccess: false,
                snackBarText: 'An error has occurred when canceling the appointment.',
            };
        }
        this.setState(stateUpdate)
    }

    render() {
        const { classes, appointments } = this.props;
        const {
            loading, cancelAppointmentConfirmationDialogOpen,
            loadingText, notifySuccess, snackBarText, snackBarOpen
        } = this.state;

        return (
            <div style={{ marginBottom: '50px' }}>

                <Dialog open={cancelAppointmentConfirmationDialogOpen} disableBackdropClick={false}
                        onBackdropClick={() => this.setState({
                            cancelAppointmentConfirmationDialogOpen: false,
                            pendingCancellingAppointmentId: null
                        })}>
                    <DialogTitle disableTypography>
                        <Typography variant="h6" color="primary" align="center"
                                    className={classes.dialogTitle}>
                            CANCEL APPOINTMENT
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle2" align="center"
                                    style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                            Are you sure of cancel your appointment?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth variant='contained'
                                onClick={() => this.setState({
                                    cancelAppointmentConfirmationDialogOpen: false,
                                    pendingCancellingAppointmentId: null
                                })}>
                            CANCEL
                        </Button>
                        <Button fullWidth color='secondary' variant='contained'
                                onClick={this.processDelete.bind(this)}>
                            YES
                        </Button>
                    </DialogActions>
                </Dialog>

                <SectionTitleContainer>
                    <SectionTitle>Pending Appointments</SectionTitle>
                </SectionTitleContainer>

                <div style={{ minHeight: '100px', backgroundColor: '#fafafa', borderBottom: 'solid 1px #ddd' }}>
                    <If as={Loading} condition={loading} style={{ padding: '30px 0' }}>
                        <Progress/><LoadingText>{loadingText}</LoadingText>
                    </If>
                    {(!loading && !appointments.length) ?
                        (
                            <Typography className={classes.emptyTypography} style={{ marginTop: 0, paddingTop: 30 }}
                                        variant='subtitle1' align="center">
                                There's not appointment registered yet
                            </Typography>
                        )
                        : (
                            <Fragment>
                                {
                                    appointments.map(item => (
                                        <div key={item.title} className={classes.itemPaper}>
                                            <div style={{ display: 'flex' }}>
                                                <Typography variant='subtitle1'>
                                                    {item.title.replace(/0+/, '')}
                                                </Typography>
                                                <div style={{ flexGrow: 1 }} className={classes.flexGrowDiv}/>
                                                {
                                                    <If condition={item.is_cancellable}>
                                                        <Button onClick={this.cancelAppointment.bind(this, item.id)}
                                                                className={classes.desktopLink}
                                                                variant='contained' color='secondary'>
                                                            CANCEL
                                                        </Button>
                                                    </If>
                                                }

                                            </div>
                                            <div className={classes.infoContainer}>
                                                <div className="rowColBlock">
                                                    <div className={classes.badgeDiv}>
                                                        <div className={classes.badgeLabel}>
                                                            <span>Price: {formatCurrency(item.price)}</span>
                                                        </div>
                                                    </div>
                                                    <div className={classes.badgeDiv}>
                                                        <div className={classes.badgeLabel}>
                                                            <span>Scheduled for: {`${formatDate(item.schedule)}  ${item.hour_slot.replace(/\s/g, '')}`}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={classes.badgeDiv}>
                                                    <div className={classes.badgeLabel}
                                                         style={{ color: '#74bd43' }}>
                                                        <span>Status: {getStatusText(item.status_key)}</span>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: '15px' }}>
                                                    {
                                                        item.devices_to_repair.split(',').map((device, i) => (
                                                                <Chip label={device} key={i}
                                                                      style={{ marginRight: '10px' }}/>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </div>

                                            <If condition={item.is_cancellable}>
                                                <Button onClick={this.cancelAppointment.bind(this, item.id)}
                                                        style={{ marginTop: '10px' }}
                                                        className={classes.mobileLink}
                                                        fullWidth variant='contained' color='secondary'>
                                                    CANCEL
                                                </Button>
                                            </If>

                                        </div>
                                    ))
                                }
                            </Fragment>
                        )
                    }
                </div>
                <Notification open={snackBarOpen}
                              type={notifySuccess ? SUCCESS_TYPE : ERROR_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({ snackBarOpen: false })}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({ snackBarOpen: false })}>
                    {snackBarText}
                </Notification>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    appointments: state.appointmentsList
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveAppointmentsList: receive_appointmentsList
    }, dispatch)
});

const PACStyled = withStyles(styles, { withTheme: true })(PendingAppointmentContent);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(PACStyled));
